/**
 * @see https://latest.api-docs-develop.ott.kaltura.com/api-docs/_Error_Codes
 */
export const ErrorCode = {
  ChannelDoesNotExist: '4064',
  CollectionNotExist: '9039',
  ExpiredKs: '500016',
  ExternalChannelNotExist: '4011',
  InvalidKS: '500015',
  NoExternalChannelToUpdate: '4012',
  ObjectNotExist: '4018',
} as const;
